import * as React from 'react';
export const eyeOpenSvg = React.forwardRef(function eyeOpenSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.476 4.89C2.2 5.884 1.5 7.065 1.5 8s.699 2.116 1.976 3.11c1.251.973 2.906 1.64 4.524 1.64 1.618 0 3.273-.667 4.524-1.64C13.8 10.116 14.5 8.935 14.5 8s-.699-2.116-1.976-3.11C11.273 3.917 9.618 3.25 8 3.25c-1.618 0-3.273.667-4.524 1.64Zm-.92-1.184C4.022 2.564 5.992 1.75 8 1.75s3.977.814 5.445 1.956C14.886 4.828 16 6.396 16 8c0 1.604-1.114 3.172-2.555 4.294C11.977 13.436 10.007 14.25 8 14.25s-3.977-.814-5.445-1.956C1.114 11.172 0 9.604 0 8c0-1.604 1.114-3.172 2.555-4.294Z',
    }),
  );
});
eyeOpenSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var eyeOpen = {
  category: 'icon',
  colorable: true,
  name: 'eyeOpen',
  svg: eyeOpenSvg,
};
